import { Currency } from "swan-public-api-client";

const saveSessionAction = "SAVE_SESSION";
const clearSessionAction = "CLEAR_TOKEN";
const saveLoginRememberAction = "SAVE_LOGIN_REMEMBER";

// state in the store
export interface LoginState {
  remember: boolean;
}
export interface SessionState {
  token?: string;
  currencies: { [key: number]: Currency };
}

// available action type definitions
interface SessionSaveAction {
  type: typeof saveSessionAction;
  session: SessionState;
}
interface SessionClearSessionAction {
  type: typeof clearSessionAction;
}
interface LoginSaveRememberAction {
  type: typeof saveLoginRememberAction;
  remember: boolean;
}

// reducers
export const session = (
  state: SessionState = { currencies: {} },
  action: SessionSaveAction | SessionClearSessionAction
): SessionState => {
  switch (action.type) {
    case saveSessionAction:
      return action.session;
    case clearSessionAction:
      return { currencies: {} };
    default:
      return state;
  }
};

export const login = (
  state: LoginState = { remember: false },
  action: LoginSaveRememberAction
): LoginState => {
  switch (action.type) {
    case saveLoginRememberAction:
      return {
        remember: action.remember
      };
    default:
      return state;
  }
};

// actions

export const saveSession = (s: SessionState): SessionSaveAction => ({
  session: s,
  type: saveSessionAction
});

export const saveLoginRemember = (
  remember: boolean
): LoginSaveRememberAction => ({ remember, type: saveLoginRememberAction });
